import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { DeleteAnnouncementsAction } from '../../actions/announcements/delete-announcements-action';
import { GetAnnouncementsAction } from '../../actions/announcements/get-announcements-action';
import { DeleteAnnouncementsErrorAction } from '../../actions/announcements/delete-announcements-error-action';


@Injectable()
export class DeleteAnnouncementsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }

  public DeleteAnnouncements = createEffect(() => this.actions
    .pipe(
      ofType(DeleteAnnouncementsAction.type),
      mergeMap(action => {
        const deleteAnnouncementsAction = <DeleteAnnouncementsAction>action;
        return this.api.deleteAnnouncements(deleteAnnouncementsAction.announcementIds).then(() => {
          return new GetAnnouncementsAction(deleteAnnouncementsAction.bijbEvent);
        }, error => {
          return new DeleteAnnouncementsErrorAction(error);
        });
      })
    ));
}
